import createInteractor from '@updater-core/interactors/sign-in/interactor';
import present from '@updater-core/interactors/sign-in/present';
import { createView } from './view';

let currentInstance;

const buildSignIn = ({
  container,
  interactors: { session, router, daisyChain },
}) => {
  container.dispatchEvent(new Event('upd-app-loaded', { bubbles: true }));

  container.classList.add('uds');
  const resetBackground = makeBackgroundNewBackgroundColor();

  const view = createView({ container });
  const interactor = createInteractor({
    interactors: { session, router, daisyChain },
  });

  interactor.connect((state) => {
    const presentation = present({
      actions: interactor.actions,
      state,
    });
    view.render(presentation);
  });

  // For Debugging
  container.setAttribute('debug', '');
  container.setAttribute('sign-in-app', '');
  container.debug = {
    interactor,
  };

  return {
    destroy: () => {
      resetBackground();
      view.destroy();
    },
  };
};

export const mount = (...args) => {
  const instance = buildSignIn(...args);
  currentInstance = instance;
};

export const unmount = () => {
  currentInstance.destroy();
};

function makeBackgroundNewBackgroundColor() {
  const styleTag = document.createElement('style');
  styleTag.textContent = `
    body {
      background-color: var(--uds-color-main-background);
    }
  `;

  document.head.appendChild(styleTag);

  return () => {
    styleTag.remove();
  };
}
